// extracted by mini-css-extract-plugin
export default {"form-text":"PhoneAsFioScreen_form-text__g6w-T","form-body":"PhoneAsFioScreen_form-body__9sz2E"};